module.exports = __webpack_public_path__ + "img/nq_icon4.db4f2925.png";